import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../CartContext";

const Navbar = () => {
  const { cart } = useContext(CartContext);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header id="mainHeader">
      <nav className="navbar">

        <Link to="/" className="logo">GGA_ARTS</Link>

        {/* Hamburger */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV LINKS */}
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/shop" onClick={() => setMenuOpen(false)}>Shop</Link></li>
          <li><Link to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link></li>
        </ul>

        {/* CART ICON */}
        <div className="cart-icon">
          <Link to="/cart" style={{ color: "#fff", textDecoration: "none" }}>
            Cart <span className="cart-count">{cart.length}</span>
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
